export type DimensionsState = {
  readonly headerHeight: number;
  // Measured height of a rental card's RED header (published on its onLayout).
  // Distinct from headerHeight (a 0.55*window Collapsed-peek value); this drives
  // the flush Header-snap geometry in ScrollableCard.
  readonly redHeaderHeight: number;
};
enum DimensionsTypes {
  PUBLISH_HEADER_HEIGHT = 'ui/dimensions/PUBLISH_HEADER_HEIGHT',
  PUBLISH_RED_HEADER_HEIGHT = 'ui/dimensions/PUBLISH_RED_HEADER_HEIGHT',
  RESET_STORE = 'RESET_STORE',
}
export default DimensionsTypes;
export type PublishHeaderHeight = {
  type: DimensionsTypes.PUBLISH_HEADER_HEIGHT;
  payload: {
    headerHeight: number;
  };
};
export type PublishRedHeaderHeight = {
  type: DimensionsTypes.PUBLISH_RED_HEADER_HEIGHT;
  payload: {
    redHeaderHeight: number;
  };
};
export type DimensionsAction = PublishHeaderHeight | PublishRedHeaderHeight;
